/*
 * Mega menu promo images are rendered with data-src / data-srcset so they
 * don't download on page load (the closed menu is visibility: hidden, which
 * doesn't stop loading="lazy" images from fetching). They are swapped in when
 * the visitor starts interacting with the desktop menu, or once the page is idle.
 */
(() => {
  const IDLE_DELAY = 3000;

  const loadImages = (root) => {
    root.querySelectorAll('.mega__menu--promo img[data-srcset], .mega__menu--promo img[data-src]').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('.header__menu').forEach((menu) => {
      const load = () => loadImages(menu);
      menu.addEventListener('pointerenter', load, { once: true });
      menu.addEventListener('focusin', load, { once: true });
    });
  };

  const loadWhenIdle = () => {
    const idle = window.requestIdleCallback || ((callback) => setTimeout(callback, 1));
    setTimeout(() => idle(() => loadImages(document)), IDLE_DELAY);
  };

  init();

  if (document.readyState === 'complete') {
    loadWhenIdle();
  } else {
    window.addEventListener('load', loadWhenIdle, { once: true });
  }

  // Theme editor re-renders the header section; load straight away there.
  document.addEventListener('shopify:section:load', (event) => loadImages(event.target));
})();
